export const numberWithCommas = (numInput: string | number) => {
  const pnum = numInput?.toString().match(/\d/g)?.join("");

  const pureNum = pnum?.split(".")[0]?.replace(/\,/g, "");

  return pureNum?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
